import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { updateLeaveType } from '../api/leaveTypes.api';
import type { UpdateLeaveTypePayload } from '../types/leaveType.types';

interface UpdateLeaveTypeArgs {
  id: number;
  payload: UpdateLeaveTypePayload;
}

export function useUpdateLeaveType(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateLeaveTypeArgs) => updateLeaveType(id, payload),
    onSuccess: () => {
      void refreshRelatedData('leaveType');
      toast.success('Leave type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update leave type');
    },
  });
}
